/** Status comerciais — slugs estáveis em Firestore; labels para UI. */
export const LEAD_STATUS = {
  NOVO: 'novo',
  CONTATO: 'contato',
  NEGOCIACAO: 'negociacao',
  /** Onboarding criado ou em curso (dashboard ou site via convite). */
  ONBOARDING: 'onboarding',
  CONVERTIDO: 'convertido',
  PERDIDO: 'perdido',
};

export const LEAD_STATUS_ORDER = [
  LEAD_STATUS.NOVO,
  LEAD_STATUS.CONTATO,
  LEAD_STATUS.NEGOCIACAO,
  LEAD_STATUS.ONBOARDING,
  LEAD_STATUS.CONVERTIDO,
  LEAD_STATUS.PERDIDO,
];

export const LEAD_STATUS_LABEL = {
  [LEAD_STATUS.NOVO]: 'Novo',
  [LEAD_STATUS.CONTATO]: 'Em contato',
  [LEAD_STATUS.NEGOCIACAO]: 'Em negociação',
  [LEAD_STATUS.ONBOARDING]: 'Onboarding',
  [LEAD_STATUS.CONVERTIDO]: 'Convertido',
  [LEAD_STATUS.PERDIDO]: 'Perdido',
};

/** Pronto para segunda vista: Kanban por status. */
export const CRM_VIEWS = {
  LIST: 'list',
  KANBAN: 'kanban',
};
